<template>
  <Modal v-model="open" :title="title">
    <Form
      ref="formItem"
      :model="formItem"
      :label-width="80"
      :rules="ruleValidate"
    >
      <FormItem label="商品名称" prop="name">
        <Input v-model="formItem.name" placeholder="请输入商品名称" clearable />
      </FormItem>
      <FormItem label="价格" prop="price">
        <Input v-model="formItem.price" placeholder="请输入价格" clearable />
      </FormItem>
      <FormItem label="库存" prop="num">
        <Input v-model="formItem.num" placeholder="请输入剩余库存" clearable />
      </FormItem>
      <FormItem label="描述" prop="desc">
        <Input v-model="formItem.desc" placeholder="请输入描述" clearable />
      </FormItem>
      <FormItem label="分类" prop="typeid">
        <Select v-model="formItem.type_id" clearable>
          <Option
            v-for="item in typeList"
            :key="item.type_id"
            :value="item.type_id"
          >
            {{ item.name }}
          </Option>
        </Select>
      </FormItem>
      <FormItem label="上传图片" prop="img">
        <Upload 
          ref="addUpload" 
          :before-upload="handleUpload" 
          accept="image/jpeg,image/jpg,image/png,image/gif"
          action
        >
          <Button v-show="!imgUrl" icon="md-cloud-upload">上传图片</Button>
          <img v-show="imgUrl" :src="imgUrl" class="uploadImgUrl" />
        </Upload>
        <div style="color: #999; font-size: 12px; margin-top: 5px;">
          支持格式：JPG、JPEG、PNG、GIF，文件大小不超过 500KB
        </div>
      </FormItem>
    </Form>
    <div slot="footer" style="text-align: center">
      <Button @click="cancel('formItem')">关闭</Button>
      <Button type="primary" :loading="loading" @click="ok('formItem')">
        提交
      </Button>
    </div>
  </Modal>
</template>
<script>
import { goodsUpdate, goodsAdd, goodsTypePage } from '@/api/goods'
import { imgUpload } from '@/api/upload'
export default {
  name: 'Goods',
  data() {
    return {
      formItem: {
        name: '',
        price: '',
        num: '',
        desc: '',
        type_id: '',
      },
      ruleValidate: {
        name: [{ required: true, message: '请输入商品名称', trigger: 'blur' }],
        price: [{ required: true, message: '请输入价格', trigger: 'blur' }],
        num: [{ required: true, message: '请输入库存', trigger: 'blur' }],
        desc: [{ required: true, message: '请输入描述', trigger: 'blur' }],
        type_id: [
          {
            required: true,
            message: '请输入商品名称',
            trigger: 'blur',
            type: 'number',
          },
        ],
      },
      typeList: [{ type_id: 2, name: '凉菜1' }],
      open: false,
      title: '商品修改',
      loading: false,
      imgUrl: '',
      uploading: false, // 图片上传状态
    }
  },
  methods: {
    // 初始化商品信息表单的函数
    init(params) {
      this.getTypeList() // 获取商品类型列表
      if (params) {
        // 如果参数存在，则进行商品修改
        this.title = '商品修改' // 设置模态框标题为商品修改
        this.formItem = JSON.parse(JSON.stringify(params)) // 深拷贝参数到formItem，避免直接修改原始数据
        this.imgUrl = process.env.VUE_APP_BASEURL + params.img // 设置图片URL
      } else {
        // 如果参数不存在，则进行商品添加
        this.cancel('formItem') // 调用取消函数，重置表单
        this.title = '商品添加' // 设置模态框标题为商品添加
      }
      this.open = true // 打开模态框
    },

    // 获取商品类型列表的函数
    getTypeList() {
      goodsTypePage() // 调用获取商品类型列表的API
        .then((res) => {
          // 处理成功的响应
          if (res.data.code === 200) {
            console.log(res.data.data)
            // 如果响应码为200，表示请求成功
            this.typeList = res.data.data // 将商品类型列表赋值给组件的数据属性
          } else {
            this.$Message.error(res.data.msg) // 如果响应码不是200，显示错误消息
          }
        })
        .catch((err) => {
          // 处理错误的响应
          this.$Message.error(err) // 显示错误消息
        })
    },

    // 确认提交表单的函数
    ok(name) {
      console.log('🔵 [商品添加] 开始提交，表单引用:', name)
      console.log('🔵 [商品添加] 表单数据:', JSON.stringify(this.formItem, null, 2))
      
      this.$refs[name].validate((valid) => {
        console.log('🔵 [商品添加] 表单验证结果:', valid)
        
        // 调用表单验证
        if (!valid) {
          console.error('❌ [商品添加] 表单验证失败，请检查必填字段')
          this.$Message.error('请填写完整的商品信息')
          return // 如果验证失败，直接返回
        }
        
        console.log('✅ [商品添加] 表单验证通过')
        console.log('🔵 [商品添加] 是否有_id:', !!this.formItem._id)
        console.log('🔵 [商品添加] API地址:', process.env.VUE_APP_BASEURL)
        
        if (this.formItem._id) {
          // 如果formItem有_id属性，表示是修改操作
          console.log('🔵 [商品修改] 开始修改商品，ID:', this.formItem._id)
          goodsUpdate(this.formItem) // 调用商品修改的API
            .then((res) => {
              console.log('✅ [商品修改] API响应:', res)
              console.log('✅ [商品修改] 响应数据:', JSON.stringify(res.data, null, 2))
              // 处理成功的响应
              if (res.data.code === 200) {
                // 如果响应码为200，表示修改成功
                console.log('✅ [商品修改] 修改成功')
                this.$Message.success('商品修改成功') // 显示成功消息
                this.cancel('formItem') // 调用取消函数，重置表单
                this.$emit('reload') // 触发reload事件，通知父组件重新加载列表
              } else {
                console.error('❌ [商品修改] 业务错误，code:', res.data.code, 'msg:', res.data.msg)
                this.$Message.error(res.data.msg) // 如果响应码不是200，显示错误消息
              }
            })
            .catch((err) => {
              console.error('❌ [商品修改] 请求异常:', err)
              console.error('❌ [商品修改] 错误详情:', {
                message: err.message,
                response: err.response,
                request: err.request,
                config: err.config
              })
              // 处理错误的响应
              const errorMsg = err.response?.data?.msg || err.message || '修改失败，请检查网络连接'
              console.error('❌ [商品修改] 错误消息:', errorMsg)
              this.$Message.error(errorMsg) // 显示错误消息
            })
        } else {
          // 如果formItem没有_id属性，表示是添加操作
          console.log('🔵 [商品添加] 开始添加商品')
          console.log('🔵 [商品添加] 提交数据:', JSON.stringify(this.formItem, null, 2))
          
          // 检查图片是否正在上传
          if (this.uploading) {
            console.warn('⚠️ [商品添加] 图片正在上传中，请稍候...')
            this.$Message.warning('图片正在上传中，请稍候再提交')
            return
          }
          
          // 检查图片是否已上传
          if (!this.formItem.img || this.formItem.img.trim() === '') {
            console.warn('⚠️ [商品添加] 图片未上传，formItem.img:', this.formItem.img)
            console.warn('⚠️ [商品添加] imgUrl:', this.imgUrl)
            
            // 如果用户选择了图片但上传失败，提示用户
            if (this.imgUrl && this.imgUrl.startsWith('data:')) {
              this.$Message.warning('图片上传失败，请重新上传图片后再提交')
              return
            }
            
            // 如果图片为空，使用默认占位图（后端要求 img 字段必填）
            console.log('⚠️ [商品添加] 使用默认图片路径')
          }
          
          // 确保数据类型正确
          const submitData = {
            name: String(this.formItem.name || '').trim(),
            price: String(this.formItem.price || '0'),
            num: Number(this.formItem.num || 0),
            desc: String(this.formItem.desc || '').trim(),
            type_id: Number(this.formItem.type_id || 0),
            // 如果图片为空，使用默认占位图（后端要求 img 字段必填）
            img: String(this.formItem.img || '').trim() || '/default-product.png'
          }
          
          console.log('🔵 [商品添加] 处理后的数据:', JSON.stringify(submitData, null, 2))
          console.log('🔵 [商品添加] 图片URL:', submitData.img)
          
          goodsAdd(submitData) // 调用商品添加的API
            .then((res) => {
              console.log('✅ [商品添加] API响应成功')
              console.log('✅ [商品添加] 完整响应:', res)
              console.log('✅ [商品添加] 响应数据:', JSON.stringify(res.data, null, 2))
              console.log('✅ [商品添加] 响应状态码:', res.status)
              
              // 处理成功的响应
              if (res.data && res.data.code === 200) {
                // 如果响应码为200，表示添加成功
                console.log('✅ [商品添加] 添加成功！')
                this.$Message.success('商品添加成功') // 显示成功消息
                this.cancel('formItem') // 调用取消函数，重置表单
                this.$emit('reload') // 触发reload事件，通知父组件重新加载列表
              } else {
                console.error('❌ [商品添加] 业务错误')
                console.error('❌ [商品添加] code:', res.data?.code)
                console.error('❌ [商品添加] msg:', res.data?.msg)
                const errorMsg = res.data?.msg || '添加失败，未知错误'
                this.$Message.error(errorMsg) // 如果响应码不是200，显示错误消息
              }
            })
            .catch((err) => {
              console.error('❌ [商品添加] 请求异常')
              console.error('❌ [商品添加] 错误对象:', err)
              console.error('❌ [商品添加] 错误类型:', typeof err)
              console.error('❌ [商品添加] 错误消息:', err.message)
              console.error('❌ [商品添加] 错误响应:', err.response)
              console.error('❌ [商品添加] 错误请求:', err.request)
              
              // 处理错误的响应
              let errorMsg = '添加失败'
              
              if (err.response) {
                // 服务器返回了错误响应
                console.error('❌ [商品添加] 服务器错误响应')
                console.error('❌ [商品添加] 状态码:', err.response.status)
                console.error('❌ [商品添加] 响应数据:', err.response.data)
                errorMsg = err.response.data?.msg || `服务器错误 (${err.response.status})`
              } else if (err.request) {
                // 请求已发送但没有收到响应
                console.error('❌ [商品添加] 请求已发送但无响应')
                console.error('❌ [商品添加] 请求对象:', err.request)
                errorMsg = '网络错误，请检查网络连接或后端服务是否运行'
              } else {
                // 其他错误
                console.error('❌ [商品添加] 其他错误:', err.message)
                errorMsg = err.message || '未知错误'
              }
              
              console.error('❌ [商品添加] 最终错误消息:', errorMsg)
              this.$Message.error(errorMsg) // 显示错误消息
            })
        }
      })
    },

    // 取消操作并关闭模态框的函数
    cancel(name) {
      this.formItem = {
        // 重置formItem对象为初始状态
        name: '', // 清空商品名称
        price: '', // 清空商品价格
        desc: '', // 清空商品描述
        type_id: '', // 清空商品类型ID
        
      }
      this.imgUrl = '' // 清空图片预览地址
      this.uploading = false // 重置上传状态
      this.$refs[name].resetFields() // 调用表单的resetFields方法，重置表单验证状态
      this.open = false // 设置模态框为关闭状态
    },
    handleUpload(file) {
      if (file) {
        // 检查文件大小
        if (file.size > 500 * 1024) {
          this.$Message.error('图片尺寸太大，请选择小于 500KB 的图片')
          this.$refs['addUpload'].clearFiles()
          return false
        }
        
        // 检查文件类型
        const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif']
        const allowedExtensions = ['jpg', 'jpeg', 'png', 'gif']
        
        // 获取文件扩展名
        const fileName = file.name || ''
        const fileExtension = fileName.split('.').pop()?.toLowerCase() || ''
        
        console.log('🖼️ [图片上传] 文件信息:', {
          name: file.name,
          type: file.type,
          size: file.size,
          extension: fileExtension
        })
        
        // 验证文件类型
        if (!allowedTypes.includes(file.type) && !allowedExtensions.includes(fileExtension)) {
          const errorMsg = `文件格式不正确，仅支持 JPG、JPEG、PNG、GIF 格式。当前文件：${file.name || '未知文件'}`
          console.error('❌ [图片上传] 文件格式验证失败:', {
            fileType: file.type,
            fileExtension: fileExtension,
            allowedTypes: allowedTypes,
            allowedExtensions: allowedExtensions
          })
          this.$Message.error(errorMsg)
          this.$refs['addUpload'].clearFiles()
          return false
        }
        
        console.log('🖼️ [图片上传] 开始上传，文件大小:', file.size, 'bytes')
        this.uploading = true // 设置上传状态
        
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = () => {
          const _base64 = reader.result
          this.imgUrl = _base64 //将_base64赋值给图片的src，实现图片预览
          console.log('🖼️ [图片上传] 预览图片已设置')
        }
        
        let formData = new FormData()
        formData.append('avatar', file)
        
        console.log('🖼️ [图片上传] 发送上传请求...')
        imgUpload(formData)
          .then((res) => {
            console.log('🖼️ [图片上传] 上传响应:', res)
            console.log('🖼️ [图片上传] 响应数据:', JSON.stringify(res.data, null, 2))
            
            if (res.data && res.data.code === 200) {
              // 获取图片URL
              const imgUrl = res.data.imgUrl || res.data.data
              console.log('✅ [图片上传] 上传成功，图片URL:', imgUrl)
              
              if (imgUrl) {
                this.formItem.img = imgUrl
                console.log('✅ [图片上传] formItem.img 已设置:', this.formItem.img)
                this.$Message.success('图片上传成功')
              } else {
                console.error('❌ [图片上传] 响应中没有 imgUrl 字段')
                console.error('❌ [图片上传] 完整响应:', res.data)
                this.$Message.error('上传成功但未获取到图片地址')
              }
            } else {
              const errorMsg = res.data?.msg || '上传失败'
              console.error('❌ [图片上传] 上传失败:', errorMsg)
              console.error('❌ [图片上传] 响应数据:', res.data)
              this.$Message.error(errorMsg)
              this.imgUrl = ''
              this.formItem.img = ''
              this.$refs['addUpload'].clearFiles()
            }
            this.uploading = false // 重置上传状态
          })
          .catch((err) => {
            console.error('❌ [图片上传] 上传异常:', err)
            console.error('❌ [图片上传] 错误详情:', {
              message: err.message,
              response: err.response,
              request: err.request
            })
            
            const errorMsg = err.response?.data?.msg || err.message || '图片上传失败，请检查网络连接'
            console.error('❌ [图片上传] 错误消息:', errorMsg)
            this.$Message.error(errorMsg)
            
            // 清除图片相关数据
            this.imgUrl = ''
            this.formItem.img = ''
            this.$refs['addUpload'].clearFiles()
            this.uploading = false // 重置上传状态
          })
        return false //阻止图片继续上传，使得form表单提交时统一上传
      }
      return false
    },
  },
  mounted() {},
}
</script>
<style lang="less" scoped>
.uploadImgUrl {
  width: 50px;
  height: 50px;
}
</style>
